import { FleetVehicleEquipment, FleetVehicleEquipmentItem } from "./types";

export const transformFleetVehicleEquipment = (res: any): FleetVehicleEquipment => ({
  id: res.id,
  cvhId: res.cvhId,
  name: res.name,
  description: res.description,
  priceEur: res.priceEur,
  finalPriceEur: res.finalPriceEur,
  isCustom: res.isCustom,
});

export const transformFleetVehicleEquipmentRequest = (
  items: FleetVehicleEquipmentItem[]
): any => ({
  items: items.map((item) => ({
    cvhId: item.cvhId,
    name: item.name,
    description: item.description,
    priceEur: item.priceEur,
    finalPriceEur: item.finalPriceEur,
    isCustom: item.isCustom,
  })),
});
